import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  wrapper: {
    marginTop: 16
  },
  contentCard: {
    marginTop: 16
  },
  contactsCard: {
    marginTop: 16,
    display: 'flex',
    flexDirection: 'column',
    gap: 20
  },
  tableFilter: {
    overflow: 'auto',
    '&::-webkit-scrollbar': {
      display: 'none!important'
    }
  },
  actionButton: {
    display: 'flex',
    alignItems: 'center',
    gap: 10
  }
}))
